export function managerPolicyReducer(state, action) {
  switch (action.type) {
    case "loadPolicy":
      return {
        ...state,
        policy: action.policy,
      };
    default:
      throw new Error();
  }
}
